module.exports = __webpack_public_path__ + "static/media/ic-discount-green.ef96f3ff.svg";